import { makeStyles } from "@material-ui/core";


const opacity = require("hex-color-opacity");


export default makeStyles((theme) => ({
    divider: {
        padding: "2px 0px",
    },
    footer: {
        display: "grid",
        color: theme.palette.grey["600"],
        alignItems: "center",
        gridTemplateColumns: "fit-content(20em) min-content auto min-content",
    },
    alertClipSelectedButton: {
        color: theme.palette.secondary.main,
    },
    alertClipButton: {
        border: "none",
    },
    alertClipButtonBackground: {
        backgroundColor: opacity(theme.palette.secondary.main, 0.2),
    },
    dashedLine: {
        height: 0,
        width: "2em",
        borderBottomStyle: "dashed",
        borderBottomWidth: 2,
        borderColor: theme.palette.grey["400"],
        flexGrow: 1,
    },
    circle: {
        height: "2em",
        width: "2em",
        borderRadium: "50%",
    },
    alertTimelineButtons: {
        display: "flex",
        alignItems: "center",
        overflowX: "auto",
        scrollbarWidth: "none" /* Firefox */,
        "&::-webkit-scrollbar": {
            display: "none" /* Safari and Chrome */,
        },
    },
    alertTimelineConnector: {
        margin: "0 -5px",
        zIndex: 1,
        display: "flex",
    },
    alertButtonFlex: {
        flexShrink: 0,
    },
    alertDetails: {
        textTransform: "capitalize",
    },
}));
